import { Event } from '../lib/types';
import EventMedia from './EventMedia';

interface EventHeaderProps {
  event: Event;
  onImageClick?: () => void;
}

export default function EventHeader({ event, onImageClick }: EventHeaderProps) {
  return <EventMedia event={event} className="w-full h-[60vh]" variant="header" showBlurBackground={true} onImageClick={onImageClick} />;
}